export default class AddToCartAnimation {

    static init() {
        this.addEventListeners();
    }

    static addEventListeners() {
        document.body.addEventListener('click', this.handleClick.bind(this));
    }

    static handleClick(event) {

        if (event.target.classList.contains('product-buy-animate')) {
            // event.preventDefault();
            const target = event.target;
            const cart = document.getElementById('snippet-header-basketSnippet');
            const wrapper = target.closest('.category-list__wrapper');
            const imgtodrag = wrapper.querySelector('img');

            if (!imgtodrag) return;

            const imgclone = imgtodrag.cloneNode(true);
            const imgcloneStyle = imgclone.style;

            const imgToDropClientPosition = imgtodrag.getBoundingClientRect();
            const cartClientPosition = cart.getBoundingClientRect();

            imgcloneStyle.top = imgToDropClientPosition.top + 'px';
            imgcloneStyle.left = imgToDropClientPosition.left + 'px';

            imgcloneStyle.opacity = 0.7;
            imgcloneStyle.position = 'fixed';
            imgcloneStyle.height = imgtodrag.clientHeight + 'px';
            imgcloneStyle.width = imgtodrag.clientWidth + 'px';
            imgcloneStyle.zIndex = 1001;
            imgcloneStyle.transition = 'all 1s ease-in-out';

            document.body.appendChild(imgclone);

            setTimeout(() => {
                imgcloneStyle.top = cartClientPosition.top + 'px';
                imgcloneStyle.left = cartClientPosition.left + 'px';
                imgcloneStyle.width = '50px';
                imgcloneStyle.height = '50px';
            }, 100);
            setTimeout(() => {
                imgclone.remove();
            }, 1000);
        }
    }
}
